module.exports = __webpack_public_path__ + "assets/img/user.26f8c017.svg";